import BaseController from "controllers/base"

class Controller extends BaseController {
  call() {
    super.call()
  }
};

export default Controller
